import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { LayoutDesktopFooterStyled } from './LayoutDesktop.styles';
import HostfullyLogo from '@/assets/images/hf-logo-white.png';

const LayoutDesktopFooter = () => {
  const showVersionNumber = false;
  const { t } = useTranslation();

  return (
    <LayoutDesktopFooterStyled>
      <div>
        <img src={HostfullyLogo} alt="Logo" width={112} height={32} />
      </div>
      <div>
        <Link to="https://help.hostfully.com/">Need help?</Link>
      </div>
      <div data-testid="copyright-notice">
        {`${new Date().getFullYear()} ${t('pageLogin.allRightsReservedFooter')}`}
        {showVersionNumber && !!globalThis.versionNumber && (
          <span data-testid="version-number" className="text-version-number">
            {` - ${globalThis.versionNumber}`}
          </span>
        )}
      </div>
    </LayoutDesktopFooterStyled>
  );
};

export default LayoutDesktopFooter;
